import { graphql } from 'react-apollo';
import component from './component';
import userQuery from '../App/userQuery.graphql';
import loginMutation from './loginMutation.graphql';

export default graphql(
  loginMutation,
  {
    name: 'handleLogin',
    options: {
      update: (proxy, { data: { login } }) => {
        const userData = proxy.readQuery({ query: userQuery });
        proxy.writeQuery({
          query: userQuery,
          data: {
            ...userData,
            user: { ...userData.user, ...login }
          }
        });
      }
    }
  }
)(component);



// WEBPACK FOOTER //
// ./src/components/Login/container.js